import { track } from 'integrations/segment/instrumentation/Track';
import { FieldsType } from './types/types';

const makeTrack = (eventKey: string) => (fields: FieldsType = {}): void => track(eventKey, fields);

export const trackCateringDraftOrderSubmitted = makeTrack('track_catering_draft_submitted');
export const trackCateringDraftOrderSubmitFailure = makeTrack('track_catering_draft_submit_failure');
export const trackCateringDraftOrderEdited = makeTrack('track_catering_draft_edited');
export const trackCateringDraftOrderEditFailure = makeTrack('track_catering_draft_edit_failure');
export const trackCateringDraftOrderCancelled = makeTrack('track_catering_draft_cancelled');
export const trackCateringDraftOrderCancelFailure = makeTrack('track_catering_draft_cancel_failure');
export const trackCateringDraftReorderStarted = makeTrack('track_catering_draft_reorder_started');
